window.addEventListener( 'resize', windowResize );

/**
 * Get read more button
 */
const seeMore = document.querySelectorAll( '.maksimer-see-more' );

/**
 * Create function to open/close read more button with more text
 */
if ( seeMore.length > 0 ) {
	seeMore.forEach( function ( button ) {
		const description = button.dataset.parent
			? document.querySelector( button.dataset.parent )
			: null;

		description.style.height = button.dataset.height + 'px';
	} );
}

document.addEventListener( 'click', ( e ) => {
	if ( ! e.target.closest( '.maksimer-see-more' ) ) return;

	const targetEl = e.target.closest( '.maksimer-see-more' ),
		description = targetEl.dataset.parent
			? document.querySelector( targetEl.dataset.parent )
			: null;

	if ( targetEl.classList.contains( 'active' ) ) {
		description.style.height = targetEl.dataset.height + 'px';
		targetEl.classList.remove( 'active' );
		targetEl.textContent = targetEl.dataset.show;
	} else {
		description.style.height = description.scrollHeight + 'px';
		targetEl.classList.add( 'active' );
		targetEl.textContent = targetEl.dataset.hide;
		targetEl.dataset.height = description.offsetHeight;
	}
} );

/**
 * Get widget heading
 */
const heading = document.querySelector(
	'.woocommerce-page .ast-woo-sidebar-widget .widget-title'
);

/**
 * Create new button for heading
 */
const newButton =
	'<button type="button" class="button"><img src="/wp-content/themes/maksimer-astra-child/assets/images/accordion_icon.png"></button>';

/**
 * Add button to widget header on mobile only
 */
if ( heading ) {
	heading.insertAdjacentHTML( 'afterbegin', newButton );
}

/**
 * Create click function for headingButton
 */
const headingButton = document.querySelector( '.button' );
if ( headingButton ) {
	headingButton.addEventListener( 'click', headBtnInteraction );
}

/**
 * Add toggle class on click
 */
function headBtnInteraction() {
	const parent = this.closest( '.widget_product_categories' );
	const child = parent.querySelector( '.product-categories' );

	if ( ! child.classList.contains( 'open-children' ) ) {
		this.classList.add( 'toggle-heading' );
		child.classList.add( 'open-children' );
	} else {
		this.classList.remove( 'toggle-heading' );
		child.classList.remove( 'open-children' );
	}
}

function openCloseProductCategory() {
	const childs = document.querySelectorAll( '.product-categories' );

	if ( window.innerWidth >= 921 ) {
		childs.forEach( function ( child ) {
			child.parentNode.classList.add( 'toggle-heading' );
			child.classList.add( 'open-children' );
		} );
	} else {
		childs.forEach( function ( child ) {
			child.parentNode.classList.remove( 'toggle-heading' );
			child.classList.remove( 'open-children' );
		} );
	}
}

openCloseProductCategory();

function windowResize() {
	openCloseProductCategory();
}
